// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"Toolbar_toolbar__RNuxV","withButtons":"Toolbar_withButtons__27jHw"};